import classNames from 'classnames/bind';
import React, { PureComponent } from 'react';
import { Form, Row } from 'react-bootstrap';
import { StepTypeMode } from '../../../../../dorian-shared/types/branch/Branch';
import { BadgeWithTooltip } from '../../../../ui/AvatarTool/BadgeWithTooltip/BadgeWithTooltip';
import { NodeEditContext } from '../context/NodeEditContext';
import { AnswerActionsBox } from './AnswerActionsBox';
import { AnswerAlternatePrices } from './AnswerAlternatePrices/AnswerAlternatePrices';
import { AnswerAutoAchievement } from './AnswerAutoAchievement/AnswerAutoAchievement';
import { AnswerEliminationText } from './AnswerEliminationText';
import { AnswerEliminationType } from './AnswerEliminationType';
import { AnswerFormData } from './AnswerFormData';
import {
  AnswerFormMemorySlotRequirement,
  VisualTreatmentIfNotMet,
} from './AnswerFormMemorySlotRequirement';
import { AnswerFormModifiers } from './AnswerFormModifiers';
import { AnswerFormTags } from './AnswerFormTags';
import { AnswerGotoBranch } from './AnswerGotoBranch';
import { AnswerPrice } from './AnswerPrice';
import { AnswerTextFields } from './AnswerTextFields';
import { AnswerType } from './AnswerType';
import styles from './Steps.scss';
import { count, ensureGamePassAlternatePrice, isGamePassAchievement } from './utils';

const cs = classNames.bind(styles);

export class AnswerForm extends PureComponent {
  showAnswerTags = (i) => {
    const { handleChangeAnswer, object } = this.props;

    const newAnswerObject = { ...object };
    newAnswerObject.showAnswerTags = !object.showAnswerTags;

    if (newAnswerObject.showAnswerTags) {
      newAnswerObject.showAnswerModifiers = false;
      newAnswerObject.showAnswerData = false;
      newAnswerObject.isSlotRequirementActive = false;
      newAnswerObject.showAltPrices = false;
      newAnswerObject.showAutoAchievement = false;
    }
    handleChangeAnswer(i, newAnswerObject);
  };

  showAnswerModifiers = (i) => {
    const { handleChangeAnswer, object } = this.props;

    const newAnswerObject = { ...object };
    newAnswerObject.showAnswerModifiers = !object.showAnswerModifiers;

    if (newAnswerObject.showAnswerModifiers) {
      newAnswerObject.showAnswerTags = false;
      newAnswerObject.showAnswerData = false;
      newAnswerObject.isSlotRequirementActive = false;
      newAnswerObject.showAltPrices = false;
      newAnswerObject.showAutoAchievement = false;
    }
    handleChangeAnswer(i, newAnswerObject);
  };

  showAnswerData = (i) => {
    const { handleChangeAnswer, object } = this.props;

    const newAnswerObject = { ...object };
    newAnswerObject.showAnswerData = !object.showAnswerData;

    if (newAnswerObject.showAnswerData) {
      newAnswerObject.showAnswerTags = false;
      newAnswerObject.showAnswerModifiers = false;
      newAnswerObject.showAltPrices = false;
      newAnswerObject.isSlotRequirementActive = false;
      newAnswerObject.showAutoAchievement = false;
    }
    handleChangeAnswer(i, newAnswerObject);
  };

  toggleShowAltPrices = (i) => {
    const { handleChangeAnswer, object } = this.props;

    const newAnswerObject = { ...object, showAltPrices: !object.showAltPrices };

    if (newAnswerObject.showAltPrices) {
      newAnswerObject.showAnswerTags = false;
      newAnswerObject.showAnswerModifiers = false;
      newAnswerObject.isSlotRequirementActive = false;
      newAnswerObject.showAnswerData = false;
      newAnswerObject.showAutoAchievement = false;
    }
    handleChangeAnswer(i, newAnswerObject);
  };

  toggleShowAutoAchievement = (i) => {
    const { handleChangeAnswer, object } = this.props;

    const newAnswerObject = { ...object, showAutoAchievement: !object.showAutoAchievement };

    if (newAnswerObject.showAutoAchievement) {
      newAnswerObject.showAnswerTags = false;
      newAnswerObject.showAnswerModifiers = false;
      newAnswerObject.isSlotRequirementActive = false;
      newAnswerObject.showAnswerData = false;
      newAnswerObject.showAltPrices = false;
    }
    handleChangeAnswer(i, newAnswerObject);
  };

  showSlotRequirement = (index) => {
    const { handleChangeAnswer, object } = this.props;
    const { answerType } = this.context;

    const newAnswerObject = { ...object };
    newAnswerObject.isSlotRequirementActive = !object.isSlotRequirementActive;

    if (newAnswerObject.isSlotRequirementActive) {
      newAnswerObject.showAnswerTags = false;
      newAnswerObject.showAnswerModifiers = false;
      newAnswerObject.showAnswerData = false;
      newAnswerObject.showAltPrices = false;
    }

    if (!newAnswerObject.requirement) {
      const currentAnswerType = answerType?.find((t) => t.id === parseInt(object.answerTypeId, 10));
      const isPassive = currentAnswerType?.value === 'passive';
      newAnswerObject.requirement = {
        check: {
          variableId: 0,
          value: 0,
          operator: 0,
        },
        visualTreatmentIfNotMet: isPassive ? VisualTreatmentIfNotMet.Disable : VisualTreatmentIfNotMet.Hide,
        isBadgeHidden: false,
      };
    }
    handleChangeAnswer(index, newAnswerObject);
  };

  handleChange = (key, value) => {
    const { handleChangeAnswer, object, answerIndex } = this.props;

    const obj = { ...object };
    obj[key] = value;
    handleChangeAnswer(answerIndex, obj);
  };

  handleGoToChange = (value) => {
    this.handleChange('gotoBranchId', value);
  };

  getBonusModifier = (modifiers) => (modifiers ? modifiers.find((mod) => {
    const { modifiersTypes } = this.context;

    if (!mod.answerModifierTypeId && mod.answerModifierTypeId !== 0) {
      return true;
    }
    const mType = this.context && modifiersTypes
      ? modifiersTypes.find((m) => m.id === parseInt(mod.answerModifierTypeId, 10))
      : null;
    return mType && mType.value === 'bonus_content';
  }) : null);

  removeBonusModifiers = (modifiers) => (modifiers ? modifiers.filter((mod) => {
    const { modifiersTypes } = this.context;
    if (!mod.answerModifierTypeId && mod.answerModifierTypeId !== 0) {
      return false;
    }
    const mType = this.context && modifiersTypes
      ? modifiersTypes.find((m) => m.id === parseInt(mod.answerModifierTypeId, 10))
      : null;
    return !mType || mType.value !== 'bonus_content';
  }) : []);

  // Price change can result in type and modifier change. Handling explicitly.
  handleAnswerPriceChange = (value) => {
    const { handleChangeAnswer, object, answerIndex } = this.props;
    const { answerType } = this.context;

    const newAnswerObject = { ...object };
    const price = parseInt(value, 10);

    newAnswerObject.answerPrice = price;
    if (price === 0) {
      const type = answerType.find((t) => t.value === 'passive');
      newAnswerObject.answerTypeId = String(type.id);
      newAnswerObject.modifiers = this.removeBonusModifiers(object.modifiers);
    } else {
      const type = answerType.find((t) => t.id === parseInt(object.answerTypeId, 10));
      if (!type || type.value === 'passive') {
        const newType = answerType.find((t) => t.value === 'active' || t.value === 'paid');
        newAnswerObject.answerTypeId = String(newType.id);
      }
    }
    handleChangeAnswer(answerIndex, newAnswerObject);
  };

  // Type change can result in price and modifier change. Handling explicitly.
  handleAnswerTypeChange = (value) => {
    const {
      handleChangeAnswer, object, answerIndex,
    } = this.props;
    const { answerType } = this.context;

    const answerObj = { ...object };
    answerObj.answerTypeId = String(value);
    const type = answerType.find((t) => t.id === parseInt(value, 10));
    if (type && type.value === 'passive') {
      answerObj.answerPrice = 0;
      answerObj.modifiers = this.removeBonusModifiers(object.modifiers);
    }

    const bonus = this.getBonusModifier(object.modifiers);
    const currentAnswerType = answerType.find((t) => t.id === parseInt(object.answerTypeId, 10));

    if (currentAnswerType) {
      answerObj.data = answerObj.data ? answerObj.data.filter((datum) => {
        if (datum.key === 'level') {
          const dataPrice = parseInt(datum.value, 10);
          if (dataPrice && dataPrice > 0 && type.value !== 'passive') {
            answerObj.answerPrice = dataPrice;
          }
          return false;
        }
        return true;
      }) : [];
    }

    if (bonus) {
      answerObj.answerPrice = 12;
    } if (type && (type.value === 'active' || type.value === 'paid')) {
      answerObj.answerPrice = 2;
    } if (type && type.value === 'erotic') {
      answerObj.answerPrice = 6;
    } if (type && type.value === 'romantic') {
      answerObj.answerPrice = 6;
    }

    handleChangeAnswer(answerIndex, answerObj);
  };

  handleChangeAnswerRequirementCheck = (values) => {
    const { object } = this.props;

    let requirementObj = {};
    if (object.requirement) {
      requirementObj = { ...object.requirement };
    }

    if (!requirementObj.check) {
      requirementObj.check = {
        operator: 'equal',
        value: 0,
        variableId: 0,
      };
    }

    values.forEach((valueObj) => {
      requirementObj.check[valueObj.name] = valueObj.value;
    });
    this.handleChange('requirement', requirementObj);
  };

  handleChangeAnswerRequirementVisual = (value) => {
    const { object } = this.props;

    let requirementObj = {};
    if (object.requirement) {
      requirementObj = { ...object.requirement };
    }
    requirementObj.visualTreatmentIfNotMet = value;
    this.handleChange('requirement', requirementObj);
  };

  handleChangeAnswerRequirementBadgeVisibility = (value) => {
    const { object } = this.props;

    let requirementObj = {};
    if (object.requirement) {
      requirementObj = { ...object.requirement };
    }
    requirementObj.isBadgeHidden = value;
    this.handleChange('requirement', requirementObj);
  };

  handleDeleteAnswerRequirement = () => {
    const { object, answerIndex, handleChangeAnswer } = this.props;
    const answerObject = { ...object };
    delete answerObject.requirement;
    answerObject.isSlotRequirementActive = false;
    handleChangeAnswer(answerIndex, answerObject);
  };

  // Modifier change can result in type and price change. Handling explicitly.
  handleChangeAnswerModifiers = (value) => {
    const { handleChangeAnswer, object, answerIndex } = this.props;
    const { answerType } = this.context;

    const obj = { ...object };
    obj.modifiers = value;
    const bonus = this.getBonusModifier(value);
    const type = answerType.find((t) => t.id === parseInt(object.answerTypeId, 10));
    if (bonus && (!type || type.value === 'passive')) {
      const newType = answerType.find((t) => t.value === 'active' || t.value === 'paid');
      obj.answerTypeId = String(newType.id);
    }
    handleChangeAnswer(answerIndex, obj);
  };

  addNewAnswer = (index) => {
    const { addAnswer } = this.props;
    if (index !== undefined) {
      addAnswer(index);
    }
  };

  deleteAnswer = (i) => {
    const { deleteAnswer: deleteAnswerFromProps } = this.props;

    deleteAnswerFromProps(i);
  };

  render() {
    const {
      step,
      stepIndex,
      answerIndex,
      activeSteps,
      disabledSortableAction,
      activeStepsFunc,
      restrictedEdit,
      object,
      user,
      index: indexFromProps,
      memoryBankSlots,
      characters,
      isEliminationCorrectOptionDisabled,
      globalContext,
    } = this.props;
    const {
      tagsTypes, currentBranchId, branches, modifiersTypes, answerType, limits, stepTypeMode, story,
    } = this.context;

    const { achievements: achievementsProvider } = globalContext;

    const answerData = object.data ? count(object.data) : 0;
    const answerTags = object.tags ? count(object.tags) : 0;
    const answerModifiers = object.modifiers ? count(object.modifiers) : 0;

    const activeClassTemplate = `steps-${stepIndex}-answers-${answerIndex}`;
    const activeClass = activeSteps ? activeSteps.startsWith(activeClassTemplate) : false;

    const slotRequirement = object.requirement && object.requirement.check ? 1 : 0;

    const isCompetitiveMode = (story?.book?.competitiveMode
      && stepTypeMode === StepTypeMode.Elimination)
        ?? false;

    const haveGamePassAchievement = achievementsProvider?.achievements?.some((achievement) => isGamePassAchievement(achievement));
    const isNotHaveGamePassAlternatePrice = !object.alternatePrices?.some(
      (alternatePrice) => isGamePassAchievement(achievementsProvider?.achievements?.find(
        (achievement) => Number(achievement.id) === Number(alternatePrice.achievementId),
      )),
    );
    const willShowGamePassTooltip = haveGamePassAchievement && isNotHaveGamePassAlternatePrice && object.answerPrice > 0;

    return (
      <div className="answerFormContainer">
        <Row
          className={cs('py-1 justify-content-between', activeClass ? 'active-item' : null)}
        >
          {restrictedEdit && (
            <Form.Control
              type="hidden"
              name={`steps[${stepIndex}][answers][${answerIndex}][id]`}
              value={object.id}
            />
          )}

          <AnswerTextFields
            answerIndex={answerIndex}
            stepIndex={stepIndex}
            object={object}
            limits={limits}
            text={object.text}
            handleTextChange={(value) => this.handleChange('text', value)}
            addNewAnswer={this.addNewAnswer}
            activeSteps={activeSteps}
            activeStepsFunc={activeStepsFunc}
          />
          {!isCompetitiveMode && (
            <>
              <AnswerGotoBranch
                sm={4}
                lg={4}
                xl={3}
                disabled={restrictedEdit}
                answerIndex={answerIndex}
                stepIndex={stepIndex}
                gotoBranchId={object.gotoBranchId}
                index={indexFromProps}
                handleChange={this.handleGoToChange}
                branches={branches}
                currentBranch={currentBranchId}
                activeStepsFunc={activeStepsFunc}
              />

              <AnswerPrice
                sm={3}
                lg={3}
                xl={2}
                disabled={restrictedEdit}
                name={`steps[${stepIndex}][answers][${answerIndex}][answerPrice]`}
                answerIndex={answerIndex}
                stepIndex={stepIndex}
                answerPrice={object.answerPrice}
                handleChange={this.handleAnswerPriceChange}
                activeStepsFunc={activeStepsFunc}
                currencyToggleSettings={step.currencyToggleSettings}
              />

              {willShowGamePassTooltip && (
                <div className="position-absolute" style={{ top: '-12px', right: '-8px', zIndex: 1000 }}>
                  <BadgeWithTooltip
                    placement="auto"
                    id="id"
                    title="Game Pass: Full Price"
                    content={(
                      <>
                        <strong>Warning!</strong>
                        <div>You have a GamePass achievement, but no alternative price is set for this answer.</div>
                        <br />
                        <div><em>GamePass users will pay the full price instead of the expected discount.</em></div>
                        <br />
                        <div><small>You can set an alternative price for this answer to avoid this situation.</small></div>
                      </>
                    )}
                    variant="primary"
                  />
                </div>
              )}

              <AnswerType
                sm={4}
                lg={3}
                xl={2}
                disabled={restrictedEdit}
                answerIndex={answerIndex}
                stepIndex={stepIndex}
                answerTypeId={object.answerTypeId}
                answerTypes={answerType}
                handleChange={this.handleAnswerTypeChange}
                activeStepsFunc={activeStepsFunc}
              />
            </>
          )}

          {isCompetitiveMode && (
            <>
              <AnswerEliminationType
                disabled={restrictedEdit}
                answerIndex={answerIndex}
                stepIndex={stepIndex}
                answerTypeId={object.answerTypeId}
                answerTypes={answerType}
                onChange={(value) => this.handleChange('eliminationResultType', value)}
                activeStepsFunc={activeStepsFunc}
                value={object.eliminationResultType}
                isCorrectOptionDisabled={isEliminationCorrectOptionDisabled}
              />

              <AnswerEliminationText
                disabled={restrictedEdit}
                answerIndex={answerIndex}
                stepIndex={stepIndex}
                answerTypeId={object.answerTypeId}
                answerTypes={answerType}
                onChange={(text) => this.handleChange('eliminationResultText', text)}
                activeStepsFunc={activeStepsFunc}
                value={object.eliminationResultText ?? ''}
                textLengthLimit={limits?.step_1_text_max?.value}
              />
            </>
          )}

          <AnswerActionsBox
            sm={12}
            md={5}
            lg={12}
            xl={12}
            user={user}
            restrictedEdit={restrictedEdit}
            object={object}
            answerIndex={answerIndex}
            stepIndex={stepIndex}
            answerModifiers={answerModifiers}
            answerTags={answerTags}
            answerData={answerData}
            deleteAnswer={this.deleteAnswer}
            answeredDataShowed={object.showAnswerData}
            showAnswerData={this.showAnswerData}
            showAnswerTags={this.showAnswerTags}
            showAnswerModifiers={this.showAnswerModifiers}
            showAltPrices={this.toggleShowAltPrices}
            showAutoAchievement={this.toggleShowAutoAchievement}
            disabledSortableAction={disabledSortableAction}
            activeStepsFunc={activeStepsFunc}
            slotRequirement={slotRequirement}
            showSlotRequirement={this.showSlotRequirement}
            isSlotRequirementActive={object.isSlotRequirementActive}
            isSlotRequirementVisible={memoryBankSlots && memoryBankSlots.length > 0}
          />
        </Row>

        <AnswerFormTags
          restrictedEdit={restrictedEdit}
          answerIndex={answerIndex}
          stepIndex={stepIndex}
          activeSteps={activeSteps}
          activeStepsFunc={activeStepsFunc}
          showAnswerTags={object.showAnswerTags}
          tags={object.tags}
          tagsTypes={tagsTypes}
          handleChangeAnswerTags={(value) => this.handleChange('tags', value)}
        />

        <AnswerFormModifiers
          restrictedEdit={restrictedEdit}
          answerIndex={answerIndex}
          stepIndex={stepIndex}
          activeSteps={activeSteps}
          activeStepsFunc={activeStepsFunc}
          showAnswerModifiers={object.showAnswerModifiers}
          modifiers={object.modifiers}
          modifiersTypes={modifiersTypes}
          handleChangeAnswerModifiers={this.handleChangeAnswerModifiers}
        />

        <AnswerFormData
          restrictedEdit={restrictedEdit}
          answerIndex={answerIndex}
          stepIndex={stepIndex}
          activeSteps={activeSteps}
          activeStepsFunc={activeStepsFunc}
          limits={limits}
          showAnswerData={object.showAnswerData}
          data={object.data}
          handleChangeAnswerData={(value) => this.handleChange('data', value)}
        />

        {object.answerPrice > 0 && (
          <AnswerAlternatePrices
            restrictedEdit={restrictedEdit}
            answerIndex={answerIndex}
            stepIndex={stepIndex}
            activeSteps={activeSteps}
            activeStepsFunc={activeStepsFunc}
            show={object.showAltPrices}
            values={object.alternatePrices}
            onChange={(value) => this.handleChange('alternatePrices', value)}
            currencyToggleSettings={step.currencyToggleSettings}
          />
        )}

        <AnswerAutoAchievement
          restrictedEdit={restrictedEdit}
          answerIndex={answerIndex}
          stepIndex={stepIndex}
          activeSteps={activeSteps}
          activeStepsFunc={activeStepsFunc}
          show={object.showAutoAchievement}
          values={object.autoAchievements}
          onChange={(value) => this.handleChange('autoAchievements', value)}
        />

        {object.requirement
        && (
        <AnswerFormMemorySlotRequirement
          isSlotRequirementActive={object.isSlotRequirementActive}
          requirement={object.requirement}
          answerIndex={answerIndex}
          stepIndex={stepIndex}
          characters={characters}
          memoryBankSlots={memoryBankSlots}
          onChangeCheckValue={this.handleChangeAnswerRequirementCheck}
          onChangeVisualEffectValue={this.handleChangeAnswerRequirementVisual}
          onChangeBadgeVisibility={this.handleChangeAnswerRequirementBadgeVisibility}
          onDeleteRequirement={this.handleDeleteAnswerRequirement}
          isPaidChoice={answerType?.find((t) => t.id === parseInt(object.answerTypeId, 10))?.value !== 'passive'}
        />
        )}
      </div>
    );
  }
}

AnswerForm.contextType = NodeEditContext;
